import { render } from "./DownloadAndWebUrl.vue?vue&type=template&id=5adc3a93&scoped=true"
import script from "./DownloadAndWebUrl.vue?vue&type=script&lang=js"
export * from "./DownloadAndWebUrl.vue?vue&type=script&lang=js"

import "./DownloadAndWebUrl.vue?vue&type=style&index=0&id=5adc3a93&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adc3a93"]])

export default __exports__